<template lang="pug">
#bet-status-parlay-mmo.modal.modal-bottom.fade.modal-bet-status(tabindex='-1' role='dialog' aria-labelledby='bet-status' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="response && response.success")
          .bet-slip
            .stake-info-wrapper
              .bet-status(:class="status ? 'waiting' : (betStatus === 'REJECT') ? 'reject' : 'confirm'")
                span {{ status ? $t('ui.waiting') : (betStatus === 'REJECT') ? $t('ui.reject') : $t('ui.confirm') }}
              .bet-league
                span {{ $t("ui.parlay")}}
              .stake-info.parlay
                .selector-odd.d-flex.justify-content-between.pb-1(v-for="item in betparlaymmo")
                  span.text(:class="isBallDisplay(item) == false ? '' : ((item.giving == 0 && item.homeAway == 2) ? 'team2' : (item.giving == 1 && item.homeAway == 1) ? 'team2' : 'team1')") {{ item.betType }} | {{ item.betDisplay }}
                  .bet-type-odds
                    template(v-if="item.fact.ball_display < 0")
                      span.negetive {{ item.fact.ball_display }}
                    template(v-else)
                      span {{ item.fact.ball_display }}
                    template(v-if="item.fact.criteria2 < 0")
                      span.mr-1.negetive ({{ item.fact.criteria2 }})
                    template(v-else)
                      span.mr-1 ({{ item.fact.criteria2 }})
                    .odds
                      span {{ $t("m.BT_" + item.beton) }}
              .payout-wrapper
                .left {{ $t("ui.stake") }}: {{ $numeral(sumparlay.stake).format("0,0.00[0]") }}
                .right {{ $t("ui.payout") }}: {{ $numeral(sumparlay.payout).format("0,0.00[0]") }}
          .footer-slip.d-flex.justify-content-around
            .btn-retain-select(@click="retainMe()") {{ $t("ui.retain_selections") }}
            .btn-continue(@click="hideMe()") {{ $t("ui.continue_bet") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import naming from "@/library/_name";
import xhr from "@/library/_xhr-betmmo.js";

export default {
  components: {},
  data() {
    return {
      betparlaymmo: {},
      items: [],
      response: null,
      sumparlay: {},
      clear: true,
      status: false,
      betStatus: "",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    commType() {
      return this.$store.getters.commType;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    isDataExists() {
      if (Object.keys(this.betparlaymmo).length > 0) {
        return true;
      } else {
        return false;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  destroyed() {
    $("#bet-status-parlay-mmo").off("shown.bs.modal", this.handleShownMe);
    $("#bet-status-parlay-mmo").off("hidden.bs.modal", this.handleHiddenMe);
  },
  mounted() {
    EventBus.betParlayStatusMMO = this.runbet;

    $("#bet-status-parlay-mmo").on("shown.bs.modal", this.handleShownMe);
    $("#bet-status-parlay-mmo").on("hidden.bs.modal", this.handleHiddenMe);
  },
  methods: {
    isBallDisplay(e) {
      // var result = naming.ballDisplay2(e.ballOrigin, e.giving, e.homeAway, e.betType, this);
      var result = naming.ballDisplay2(e.fact.ball_display, e.giving, e.homeAway, e.betType, this);
      if (["HDP", "HDPH"].includes(e.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    runbet(e, s, f) {
      this.betparlaymmo = e;
      this.sumparlay = s;
      this.response = f;
      this.status = f.data.pending;
      this.showMe();
    },
    showMe() {
      $("#bet-status-parlay-mmo").modal("show");
      this.betStatus = "";
      this.populateList();
    },
    hideMe() {
      $("#bet-status-parlay-mmo").modal("hide");
    },
    retainMe() {
      this.clear = false;
      $("#bet-status-parlay-mmo").modal("hide");
    },
    handleShownMe() {
      this.clear = true;
    },
    handleHiddenMe() {
      if (this.clear) {
        if (EventBus.cancelParlayMMO) {
          EventBus.cancelParlayMMO();
        }
      }
    },
    populateList(callback) {
      if (this.isLoggedIn) {
        this.loading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: this.response.data.betId,
          bet_type: 'PARLAYMMO'
        };
        xhr.betStatus(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                this.betStatus = res.data[0].bet_status;
                this.status = res.data[0].bet_status === 'PENDING';
                if(this.betStatus == 'PENDING') {
                  setTimeout(() => {
                    this.populateList()
                  }, 4000);
                } else {
                  this.status = false;
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    }
  }
};
</script>